<template>
  <div style="display:inline-block">
    <!-- 所有页面 顶部 面包屑 右侧 -->
    <el-popover
      placement="left"
      width="50"
      trigger="hover" v-if="popoverType==11">
      <div class="popver-box">
        <span>{{info}}</span>
        <!-- <EvalMethods :popoverType="popoverType"/> -->
      </div>
      <span slot="reference"><i class="el-icon-question icon-20 my-question"></i></span>
    </el-popover>
    <!-- <span slot="reference"
          v-if="popoverType==11"><i class="el-icon-question tl-question"></i>
    </span> -->
  </div>
</template>

<script>
// import EvalMethods from './EvalMethods'
import { baseUrl } from '@/config/env'
export default {
  name: 'HelpPage',
  // components: { EvalMethods },
  props: {
    popoverType: {
      type: Number,
      default: 5
    }
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        // console.log(newVal)
      },
      deep: true
    }
  },
  data () {
    return {
      info: '',
      docUrl: baseUrl + '/doc/Identification-and-classification-of-major-hazards.doc'
    }
  },
  created () {
    this.info = this.$route.meta.title
    // console.log(this.$route)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.icon-20 {
  font-size: 26px;
  position: relative;
  top: 4px;
}
</style>
<style lang="scss">
.el-popper.top-520 {
  top: 520px !important;
}
@media screen and(max-height: 750px) {
  .el-popper.top-10 {
    top: 0px !important;
    overflow-y: auto;
    max-height: 100%;
  }
}
</style>
